export default __webpack_public_path__ + "static/media/speakers__rob-rhyne.90c6739e.jpg";